<template>

    <v-container fluid class="pa-0">

        <v-row justify="center">
            <v-col v-if="products.length >= 1" xs="12" sm="6" md="6" lg="4" xl="4" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[0]"></SingleImageLookbook>
            </v-col>
            <v-col v-if="products.length >= 2" xs="12" sm="6" md="6" lg="4" xl="4" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[1]"></SingleImageLookbook>
            </v-col>
            <v-col v-if="products.length >= 3" xs="12" sm="6" md="6" lg="4" xl="4" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[2]"></SingleImageLookbook>
            </v-col>


            <v-col v-if="products.length >= 4" xs="12" sm="6" md="6" lg="3" xl="3" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[3]"></SingleImageLookbook>
            </v-col>
            <v-col v-if="products.length >= 5" xs="12" sm="6" md="6" lg="3" xl="3" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[4]"></SingleImageLookbook>
            </v-col>
            <v-col v-if="products.length >= 6" xs="12" sm="6" md="6" lg="3" xl="3" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[5]"></SingleImageLookbook>
            </v-col>
            <v-col v-if="products.length >= 7" xs="12" sm="6" md="6" lg="3" xl="3" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[6]"></SingleImageLookbook>
            </v-col>
        </v-row>

        <v-row justify="center" class="ma-8">
            <v-col cols="auto">
                <v-btn outlined href="https://positano-couture.myshopify.com/" target="_blank">
                    {{$t('lookbook.visitShop')}}
                </v-btn>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col v-if="products.length >= 8" xs="12" sm="6" md="6" lg="4" xl="4" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[7]"></SingleImageLookbook>
            </v-col>
            <v-col v-if="products.length >= 9" xs="12" sm="6" md="6" lg="4" xl="4" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[8]"></SingleImageLookbook>
            </v-col>
            <v-col v-if="products.length >= 10" xs="12" sm="6" md="6" lg="4" xl="4" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[9]"></SingleImageLookbook>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col v-if="products.length >= 11" xs="12" sm="6" md="6" lg="6" xl="6" class="pa-3 ma-0">
                <SingleImageLookbook :product="products[10]"></SingleImageLookbook>
            </v-col>
        </v-row>

    </v-container>


</template>

<script>

    import SingleImageLookbook from "../components/SingleImageLookbook";

    export default {
        name: "TemplateLookbook",
        components: {SingleImageLookbook},
        props: ["products"],

        data: () => ({
        }),
    }
</script>

<style scoped>

</style>